import { makeColorSchema, rainbowRandomColors } from '../color-utils';
export const rainbowStyle = makeColorSchema(rainbowRandomColors[0]);
//# sourceMappingURL=rainbow.style.js.map